import {connect} from 'react-redux';
import {denormalize} from 'normalizr';

import {schema} from '../../../../../state/schema';
import {loadCareGuideSections, deleteCareGuideSection} from '../../../../../state/modules/careGuideSections/actions';
import {sendMessage} from '../../../../../state/actions';
import CareGuideSectionsList from '../components/CareGuideSectionsList';

const mapStateToProps = (state, ownProps) => {

  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.careGuideSections.getIn(['pages', order, limit, page]);

  return {
    list: result 
      ? result.map(x => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['careGuideSections', x]),
              schema.careGuideSection,
              state.entities.toJS()
            )
          };
        }).toArray()
      : [],
    isLoading: state.careGuideSections.get('isLoading'),
    total: state.careGuideSections.get('total'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadCareGuideSections(page, limit, order, filter, cb));
    },
    remove: (id, cb) => {
      dispatch(deleteCareGuideSection(id, cb));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  }
}

const CareGuideSectionsListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CareGuideSectionsList);

export default CareGuideSectionsListContainer;
